// extracted by mini-css-extract-plugin
export default {"bg-image":"bg-image__fakEu","provider-link":"provider-link__4pOgG"};